import { render, staticRenderFns } from "./SidebarChildListItem.vue?vue&type=template&id=f53acccc&"
import script from "./SidebarChildListItem.vue?vue&type=script&lang=js&"
export * from "./SidebarChildListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports